
/**
 * 通知
 * wrap of "notifyjs"
 *http://notifyjs.jpillora.com/
 * npm "notifyjs-browser": "0.4.2"
 *
 */

//import * as $ from 'jquery';


//下記の問題もあるのでtoasterにきりかえるかもしれない！
//ライブラリの作りが悪い！SPAにすると,<head>にビルドインのstyleタグを埋め込んでしまうため重複する。存在すれば消す

//#515 Notifyだけは、Extarnalにして,外部ファイルにしても,なぜかうまくいかない(ライブラリの作りがそうなっているらしい)
//importは禁ずる
//$('head #notify-bootstrap').remove();
////下は初回なぜか2つ刺さる(タイミングの問題だと思う)
//$('head #core-notify').remove();
//$('div.notifyjs-corner').remove();
//import 'notifyjs-browser';

/**
 * 
 */
export type notifyOptions = {
    // whether to hide the notification on click
    clickToHide?: boolean;
    // whether to auto-hide the notification
    autoHide?: boolean;
    // if autoHide, hide after milliseconds
    autoHideDelay?: number;
    // show the arrow pointing at the element
    arrowShow?: boolean;
    // arrow size in pixels
    arrowSize?: number;
    // position defines the notification position though uses the defaults below
    position?: any;
    // default positions
    //elementPosition?: string;
    // default positions(window)
    //globalPosition?: string;
    // default style
    style?: string;
    //// default class (string or [string])
    //className: 'error';
    // show animation
    showAnimation?: string;
    // show animation duration
    showDuration?: number;
    // hide animation
    hideAnimation?: string;
    // hide animation duration
    hideDuration?: number;
    // padding between element and notification
    gap?: number;
}

const DefaultNotifyOptions: notifyOptions = {
    // whether to hide the notification on click
    clickToHide: true,
    // whether to auto-hide the notification
    autoHide: true,
    // if autoHide, hide after milliseconds
    autoHideDelay: 5000,
    // show the arrow pointing at the element
    arrowShow: true,
    // arrow size in pixels
    arrowSize: 5,
    // position defines the notification position though uses the defaults below
    //position: 'top center',
    // default style
    //style: 'bootstrap',
    style: 'spirit',
    //// default class (string or [string])
    //className: 'error',
    // show animation
    showAnimation: 'slideDown',
    // show animation duration
    showDuration: 400,
    // hide animation
    hideAnimation: 'slideUp',
    // hide animation duration
    hideDuration: 400,
    // padding between element and notification
    gap: 2
}


//export class Notify {
//    /**
//     * 
//     * @param content
//     * @param options
//     */
//    static info(content: string | Element, options?: notifyOptions) {
//        Notify.show(content, 'info', options);
//    };
//    /**
//     * 
//     * @param content
//     * @param options
//     */
//    static success(content: string | Element, options?: notifyOptions) {
//        Notify.show(content, 'success', options);
//    };
//    /**
//     * 
//     * @param content
//     * @param options
//     */
//    static warn(content: string | Element, options?: notifyOptions) {
//        Notify.show(content, 'warn', options);
//    };
//    /**
//     * 
//     * @param content
//     * @param options
//     */
//    static error(content: string | Element, options?: notifyOptions) {
//        Notify.show(content, 'error', options);
//    };

//    /**
//     * 
//     * @param content
//     * @param className
//     * @param options
//     */
//    private static show(content: string | Element, className: 'info' | 'success' | 'warn' | 'error', options?: notifyOptions) {

//        //for customize
//        //const _options = $.extend(true, {}, customStyle, options);
//        options = options || DefaultNotifyOptions;
//        const _options = $.extend(true, {}, options, { className: className });
//        $.notify(content, _options);
//    };




$.notify.addStyle("spirit", {
    //html: "<div><span data-notify-text></span></div>",
    html: '<div>' +
        '  <div class="d-flex align-items-center">' +
        '    <div class="notify-icon">' +
        '      <i class="material-icons m-2" data-notify-text="icon"></i>' +
        "    </div>" +
        '    <div class="notify-title m-2" data-notify-html="title"/>' +
        '  </div>' +
        '</div>',

    //classes: {
    //    base: {
    //        "font-weight": "bold",
    //        "padding": "8px 15px 8px 14px",
    //        //"text-shadow": "0 1px 0 rgba(255, 255, 255, 0.5)",
    //        "background-color": "#fcf8e3",
    //        "border": "1px solid #fbeed5",
    //        "border-radius": "4px",
    //        "white-space": "nowrap",
    //        "padding-left": "25px",
    //        //"background-repeat": "no-repeat",
    //        //"background-position": "3px 7px"
    //    },
    //    error: {
    //        "color": "#B94A48",
    //        "background-color": "#F2DEDE",
    //        "border-color": "#EED3D7",
    //    },
    //    success: {
    //        "color": "#468847",
    //        "background-color": "#DFF0D8",
    //        "border-color": "#D6E9C6",
    //    },
    //    info: {
    //        "color": "#3A87AD",
    //        "background-color": "#D9EDF7",
    //        "border-color": "#BCE8F1",
    //    },
    //    warn: {
    //        "color": "#C09853",
    //        "background-color": "#FCF8E3",
    //        "border-color": "#FBEED5",
    //    }
    //}
});
$.notify.addStyle("spirit", {
    //html: "<div><span data-notify-text></span></div>",
    html: '<div>' +
        '  <div class="d-flex align-items-center">' +
        '    <div class="notify-icon">' +
        '      <i class="material-icons m-2" data-notify-text="icon"></i>' +
        "    </div>" +
        '    <div class="notify-title m-2" data-notify-html="title"/>' +
        '  </div>' +
        '</div>',

    //classes: {
    //    base: {
    //        "font-weight": "bold",
    //        "padding": "8px 15px 8px 14px",
    //        //"text-shadow": "0 1px 0 rgba(255, 255, 255, 0.5)",
    //        "background-color": "#fcf8e3",
    //        "border": "1px solid #fbeed5",
    //        "border-radius": "4px",
    //        "white-space": "nowrap",
    //        "padding-left": "25px",
    //        //"background-repeat": "no-repeat",
    //        //"background-position": "3px 7px"
    //    },
    //    error: {
    //        "color": "#B94A48",
    //        "background-color": "#F2DEDE",
    //        "border-color": "#EED3D7",
    //    },
    //    success: {
    //        "color": "#468847",
    //        "background-color": "#DFF0D8",
    //        "border-color": "#D6E9C6",
    //    },
    //    info: {
    //        "color": "#3A87AD",
    //        "background-color": "#D9EDF7",
    //        "border-color": "#BCE8F1",
    //    },
    //    warn: {
    //        "color": "#C09853",
    //        "background-color": "#FCF8E3",
    //        "border-color": "#FBEED5",
    //    }
    //}
});



/**
 * 
 * @param content
 * @param className
 * @param options
 */
function show(content: string | Element, icon = 'notifications', className: 'info' | 'success' | 'warn' | 'error', options?: notifyOptions) {

    //for customize
    //const _options = $.extend(true, {}, customStyle, options);
    //options = options || DefaultNotifyOptions;
    //const _options = $.extend(true, {}, options, { className: className, style: 'bootstrap' });
    //const _options = $.extend(true, {}, options, { className: className, style: 'spirit' });
    const _options = $.extend(true, {}, DefaultNotifyOptions, options, { className: className });


    //$.notify(content, _options);
    const data = {
        title: content,
        icon: icon,
    };


    $.notify(data, _options);
}



/**
 * 
 * @param content
 * @param className
 * @param options
 */
function showElement(target: any, content: string | Element, icon = 'notifications', className: 'info' | 'success' | 'warn' | 'error', isCompact = true, options?: notifyOptions) {

    //for customize
    //const _options = $.extend(true, {}, customStyle, options);
    //options = options || DefaultNotifyOptions;
    //const _options = $.extend(true, {}, options, { className: className, style: 'bootstrap' });
    //const _options = $.extend(true, {}, options, { className: className, style: 'spirit' });
    if (isCompact) {
        className += ' compact';
    }
    const _options = $.extend(true, {}, DefaultNotifyOptions, options, { className: className });


    //$.notify(content, _options);
    const data = {
        title: content,
        icon: icon,
    };


    $(target).notify(data, _options);
}

export const Notify = {

    /**
     * 
     * @param content
     * @param options
     */
    info(content: string | Element, options?: notifyOptions) {
        show(content, 'info', 'info', options);
    },
    /**
     * 
     * @param content
     * @param options
     */
    success(content: string | Element, options?: notifyOptions) {
        show(content, 'check_circle', 'success', options);
    },
    /**
     * 
     * @param content
     * @param options
     */
    warn(content: string | Element, options?: notifyOptions) {
        show(content, 'warning', 'warn', options);
    },
    /**
     * 
     * @param content
     * @param options
     */
    error(content: string | Element, options?: notifyOptions) {
        show(content, 'error', 'error', options);
    },

    /**
     * 
     * @param content
     * @param options
     */
    element(target: string | Element | JQuery<HTMLElement>, content: string | Element, options?: notifyOptions, icon = 'notifications', className: 'info' | 'success' | 'warn' | 'error' = 'info', isCompact = true) {
        showElement(target, content, icon, className, isCompact, options);
    }

}